export default "__VITE_ASSET__7bb8d506__"